import { library } from '@fortawesome/fontawesome-svg-core';
import { type IconDefinition } from '@fortawesome/pro-regular-svg-icons'; // ✅ Moved here

// Regular (far)
import {
    faArrowLeft as farArrowLeft,
    faArrowRight as farArrowRight,
    faBackwardStep as farBackwardStep,
    faBookmark as farBookmark,
    faCheckCircle as farCheckCircle,
    faClock as farClock,
    faCopy as farCopy,
    faFaceSmile as farFaceSmile,
    faHeart as farHeart,
    faHome as farHome,
    faStar as farStar,
    faXmark as farXmark,
} from '@fortawesome/pro-regular-svg-icons';

// Solid (fas)
import {
    faCheckCircle as fasCheckCircle,
    faCircleUser as fasCircleUser,
    faClock as fasClock,
    faHeart as fasHeart,
    faMessageDots as fasMessageDots,
    faStar as fasStar,
} from '@fortawesome/pro-solid-svg-icons';

// Light (fal)
import { faBookmark as falBookmark, faGear as falGear, faHome as falHome, faMessageDots as falMessageDots } from '@fortawesome/pro-light-svg-icons';

// Add all icons to FontAwesome's global library
library.add(
    falBookmark,
    falGear,
    falHome,
    falMessageDots,
    farArrowLeft,
    farArrowRight,
    farBackwardStep,
    farBookmark,
    farCheckCircle,
    farClock,
    farCopy,
    farFaceSmile,
    farHeart,
    farHome,
    farStar,
    farXmark,
    fasCheckCircle,
    fasCircleUser,
    fasClock,
    fasHeart,
    fasMessageDots,
    fasStar,
);

export {
    falBookmark,
    falGear,
    falHome,
    falMessageDots,
    farArrowLeft,
    farArrowRight,
    farBackwardStep,
    farBookmark,
    farCheckCircle,
    farClock,
    farCopy,
    farFaceSmile,
    farHeart,
    farHome,
    farStar,
    farXmark,
    fasCheckCircle,
    fasCircleUser,
    fasClock,
    fasHeart,
    fasMessageDots,
    fasStar,
};

export type { IconDefinition };
